import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.benutzer-zum-dienst-einteilen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenBenutzerZumDienstEinteilenEffects {

    BenutzerZumDienstEinteilen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BENUTZER_ZUM_DIENST_EINTEILEN),
        mergeMap((x: ac.PostBenutzerZumDienstEinteilenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBenutzerZumDienstEinteilen(x.benutzerZumDienstEinteilenRequest).pipe(
                map((result: any) => {
                    return new ac.PostBenutzerZumDienstEinteilenErfolgreichAction(result, x.benutzerZumDienstEinteilenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBenutzerZumDienstEinteilenFehlerAction(error, x.benutzerZumDienstEinteilenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.RollenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.RollenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.RollenCommandService);
        }
        return this.service;
    }
}
